import { render, staticRenderFns } from "./CardiovascularValue.vue?vue&type=template&id=956a8de2&scoped=true"
import script from "./CardiovascularValue.vue?vue&type=script&lang=js"
export * from "./CardiovascularValue.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "956a8de2",
  null
  
)

export default component.exports